import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar2 from '../Components/NavBar2';
// import { deleteUser } from 'firebase/auth'; // Uncomment and configure if using Firebase
// import { auth, firestore } from '../firebase'; // Your firebase config

function DeleteAccount() {
  const [confirmed, setConfirmed] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleDelete = async () => {
    if (!confirmed) return;
    setLoading(true);

    try {
      // Example logic using Firebase (uncomment and configure based on your setup)
      // const user = auth.currentUser;
      // await firestore.collection('users').doc(user.uid).delete(); // Delete user data
      // await deleteUser(user); // Delete auth account

      alert("Your account has been deleted."); // Replace with toast/snackbar
      navigate('/'); // Redirect to home or goodbye page
    } catch (error) {
      console.error("Error deleting account:", error);
      alert("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
        <NavBar2/>
            <div className="container py-5">
      <h1 className="mb-4 text-danger mt-5">Delete Account</h1>
      <p className="lead">
        Deleting your account is permanent. This will:
      </p>
      <ul>
        <li>Erase all your data from Kuza Points</li>
        <li>Revoke your access to the app</li>
        <li>Delete your loyalty and transaction records</li>
        <li>Remove your user profile and business info</li>
      </ul>

      <div className="form-check mt-4">
        <input
          className="form-check-input"
          type="checkbox"
          checked={confirmed}
          onChange={() => setConfirmed(!confirmed)}
          id="confirmDelete"
        />
        <label className="form-check-label" htmlFor="confirmDelete">
          I understand the consequences of deleting my account permanently.
        </label>
      </div>

      <button
        className="btn btn-danger mt-4"
        onClick={handleDelete}
        disabled={!confirmed || loading}
      >
        {loading ? "Deleting..." : "Delete My Account"}
      </button>
    </div>
    </div>

  );
}

export default DeleteAccount;
